var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_249_821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.727 14.3225C27.727 13.3709 27.6499 12.414 27.4852 11.4778H14.28V16.8689H21.842C21.5282 18.6077 20.52 20.1458 19.0436 21.1232V24.6213H23.555C26.2043 22.1829 27.727 18.582 27.727 14.3225Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.28 28.0009C18.0558 28.0009 21.2401 26.7611 23.5602 24.6211L19.0487 21.1231C17.7935 21.977 16.1731 22.4606 14.2851 22.4606C10.6327 22.4606 7.53591 19.9965 6.42476 16.6836H1.76924V20.2897C4.14587 25.0172 8.98659 28.0009 14.28 28.0009Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41963 16.6837C5.83319 14.9449 5.83319 13.0621 6.41963 11.3234V7.71729H1.76925C-0.216419 11.6732 -0.216419 16.3339 1.76925 20.2898L6.41963 16.6837Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.28 5.54127C16.2759 5.51041 18.205 6.26146 19.6506 7.64012L23.6476 3.64305C21.1167 1.26642 17.7575 -0.0402103 14.28 0.000943444C8.98658 0.000943444 4.14587 2.98459 1.76924 7.71728L6.41962 11.3234C7.52562 8.00536 10.6276 5.54127 14.28 5.54127Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_249_821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.317e140b182dc48c75cb474b9bb07f12.svg";
export { ForwardRef as ReactComponent };